import { Component } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'update-security-info',
	template: require('./update-security-info.component.html'),
	host: { class: 'flex-column ' },
})
export class UpdateSecurityInfoComponent {
	public isRebrading = AppSettings.isRebrading;
}
